import {KTSVG, toAbsoluteUrl} from '../../_metronic/helpers'
import {useHistory} from 'react-router-dom'

export function AddWebsiteLeftBreadcrum(props: any) {
  const history: any = useHistory()
  function selectedTick(step: number) {
    if (props.currentStep < step) {
      return (
        <span className='ms-4 BrandIcon svg-icon flex svg-icon-gray-800 bg-gray-100 w-40px h-40px rounded'>
          <KTSVG path={toAbsoluteUrl('/media/icons/Custom/Active.svg')} />
        </span>
      )
    } else if (props.currentStep == step) {
      return (
        <span className='ms-4 BrandIcon svg-icon flex svg-icon-warning bg-warning-custom-light  w-40px h-40px rounded'>
          <KTSVG path={toAbsoluteUrl('/media/icons/Custom/Active.svg')} />
        </span>
      )
    } else if (props.currentStep > step) {
      return (
        <span className='ms-4 svg-icon flex svg-icon-gray-300 bg-success-dark w-40px h-40px rounded'>
          <KTSVG path={toAbsoluteUrl('/media/icons/Custom/Active.svg')} />
        </span>
      )
    }
  }
  // var dashedLine =
  //   props.currentStep > 1
  //     ? toAbsoluteUrl('/media/icons/Custom/Line.svg')
  //     : toAbsoluteUrl('/media/icons/Custom/LineGray.svg')
  const returnLine = (i:any)=>{
    if(parseInt(props.currentStep)===i){
      return toAbsoluteUrl('/media/icons/Custom/Line.svg')
    } else if (parseInt(props.currentStep)>i){
      return toAbsoluteUrl('/media/icons/Custom/LineGreen.svg')
    } else {
      return toAbsoluteUrl('/media/icons/Custom/LineGray.svg')
    }
  }
  return (
    <div>
      <div className='BrandSteps' style={{marginTop: '20px'}}>
        <div className='row'>
          {selectedTick(1)}
          <span className='col-8 cursor-pointer' onClick={()=>{
            if(history.location.state.edit){
              history.push({
                pathname: '/editWebsite/' + history.location.state.website._id,
                state: {
                  ...history.location.state,
                  id: history.location.state.website._id
                },
              })
            }
          }}>
            <div className='fs-8 text-gray-500'>Step 1</div>
            <div className='fw-bolder'>Website Details</div>
          </span>
        </div>
        <span className='ms-1 BrandLine svg-icon svg-icon-3x'>
          <KTSVG
            path={
              props.currentStep > 1
                ? toAbsoluteUrl('/media/icons/Custom/LineGreen.svg')
                : toAbsoluteUrl('/media/icons/Custom/Line.svg')
            }
          />
        </span>
        <div className='row mt-10'>
          {selectedTick(2)}
          <span className='col-8 cursor-pointer' onClick={()=>{
            if(history.location.state.edit){
              history.push({
                pathname: '/addWebsite/type',
                state: {
                  ...history.location.state,
                  id: history.location.state.website._id
                },
              })
            }
          }}>
            <div className='fs-8 text-gray-500'>Step 2</div>
            <div className='fw-bolder'>
              WebsiteType
            </div>
          </span>
        </div>
        <span className='ms-1 BrandLine svg-icon svg-icon-3x'>
          <KTSVG
            path={returnLine(2)}
          />
        </span>
        <div className='row mt-10'>
          {selectedTick(3)}
          <span className='col-8  cursor-pointer' onClick={()=>{
            if(history.location.state.edit){
              history.push({
                pathname: '/addWebsite/categories',
                state: {
                  ...history.location.state,
                  id: history.location.state.website._id
                },
              })
            }
          }}>
            <div className='fs-8 text-gray-500'>Step 3</div>
            <div className='fw-bolder'>Website Categories</div>
          </span>
        </div>
        <span className='ms-1 BrandLine svg-icon svg-icon-3x'>
          <KTSVG
            path={returnLine(3)}
          />
        </span>
        <div className='row mt-10'>
          {selectedTick(4)}
          <span className='col-8  cursor-pointer' onClick={()=>{
            if(history.location.state.edit){
              history.push({
                pathname: '/addWebsite/tags',
                state: {
                  ...history.location.state,
                  id: history.location.state.website._id
                },
              })
            }
          }}>
            <div className='fs-8 text-gray-500'>Step 4</div>
            <div className='fw-bolder'>Website Tags & Phrases</div>
          </span>
        </div>
        {/* <span className='ms-1 BrandLine svg-icon svg-icon-3x'>
          <KTSVG
            path={returnLine(4)}
          />
        </span>
        <div className='row mt-10'>
          {selectedTick(5)}
          <span className='col-8  cursor-pointer' onClick={()=>{
            if(history.location.state.edit){
              history.push({
                pathname: '/addWebsite/associated-pages',
                state: {
                  ...history.location.state,
                  id: history.location.state.website._id
                },
              })
            }
          }}>
            <div className='fs-8 text-gray-500'>Step 5</div>
            <div className='fw-bolder'>Associated Pages</div>
          </span>
        </div>
        <span className='ms-1 BrandLine svg-icon svg-icon-3x'>
          <KTSVG
            path={returnLine(5)}
          />
        </span>
        <div className='row mt-10'>
          {selectedTick(6)}
          <span className='col-8 cursor-pointer' onClick={()=>{
            if(history.location.state.edit){
              history.push({
                pathname: '/addWebsite/associated-components',
                state: {
                  ...history.location.state,
                  id: history.location.state.website._id
                },
              })
            }
          }}>
            <div className='fs-8 text-gray-500'>Step 6</div>
            <div className='fw-bolder'>Associate Components</div>
          </span>
        </div> */}
      </div>
    </div>
  )
}
